export enum ExtraProductFieldType {
  TEXT = "TEXT",
}
